import React from 'react';
import PropTypes from 'prop-types';
import Utils from 'neon-frontend-utils/src/utils';
import ProductTypes from 'neon-frontend-utils/src/components/Report/constants/ProductTypes';
import SectionBlock from 'neon-frontend-utils/src/components/Report/components/SectionBlock/SectionBlock';
import style from './style/placeholder.scss';

export const Placeholder = props => {
    const { i18nParticipation, classes, handle, basedOn, title } = props;

    const getExplanationText = handle => {
        const translationKey = `report_section_placeholder_explanation_text_${Utils.camelCaseToSnakeCase(handle)}`;

        return i18nParticipation[translationKey] || translationKey;
    }

    const getExplanationTitle = handle => {
        const translationKey = `report_section_placeholder_explanation_title_${Utils.camelCaseToSnakeCase(handle)}`;

        return i18nParticipation[translationKey] || translationKey;
    }

    return <SectionBlock
        classes={{
            root: `${style.placeholderSection} ${classes.root}`,
            badge: classes.badge
        }}>
        <span className={style.placeholderSubtitle}>{basedOn}</span>
        <h3 className={style.placeholderTitle}>{title}</h3>
        <div className={style.placeholderContentWrapper}>
            <figure><img src={'/portal/assets/images/placeholder_icon.png'} alt=""/></figure>
            <strong>{getExplanationTitle(handle)}</strong>
            <p>{getExplanationText(handle)}</p>
        </div>
    </SectionBlock>
};

Placeholder.propTypes = {
    i18nParticipation: PropTypes.object,
    classes: PropTypes.object,
    handle: PropTypes.string,
    basedOn: PropTypes.string,
    title: PropTypes.string
};

Placeholder.defaultProps = {
    classes: {
        root: '',
        badge: ''
    }
};
